import React, { useEffect, useState } from 'react';
import { XIcon, HeartIcon, SparklesIcon } from 'lucide-react';
const PURCHASE_URL = 'https://zdn5g0-8y.myshopify.com/cart/46443612143789:1?channel=buy_button';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    let shown = false;
    const show = () => {
      if (!shown) {
        shown = true;
        setIsVisible(true);
      }
    };
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      show();
    };
    // Push extra history entry so first Back press triggers popstate
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-md" data-id="element-347">
      <div className="relative bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#1a0505] via-black to-black rounded-3xl shadow-[0_0_60px_rgba(212,175,55,0.25)] max-w-lg w-full overflow-hidden border border-[#d4af37]/30" data-id="element-348">
        {/* Neon glows */}
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-40 bg-red-900/40 rounded-full blur-3xl pointer-events-none" data-id="element-349" />
        <div className="absolute -bottom-16 -right-10 w-56 h-56 bg-[#d4af37]/10 rounded-full blur-3xl pointer-events-none" data-id="element-350" />

        {/* Top accent bar */}
        <div className="h-1.5 bg-gradient-to-r from-[#d4af37] via-[#f3e5ab] to-[#d4af37] w-full shadow-[0_0_15px_rgba(212,175,55,0.5)]" data-id="element-351" />

        {/* Close button */}
        <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 text-slate-500 hover:text-white transition-colors z-10" aria-label="Cerrar" data-id="element-352">
          <XIcon className="h-6 w-6" data-id="element-353" />
        </button>

        <div className="p-8 relative z-10" data-id="element-354">
          {/* Icon */}
          <div className="flex justify-center mb-5" data-id="element-355">
            <div className="relative" data-id="element-356">
              <div className="absolute inset-0 bg-red-900/40 rounded-full blur-xl scale-150" data-id="element-357" />
              <div className="relative bg-gradient-to-br from-red-800 to-red-950 rounded-2xl p-4 shadow-[0_0_30px_rgba(153,27,27,0.6)] border border-red-700/40" data-id="element-358">
                <HeartIcon className="h-9 w-9 text-[#d4af37] drop-shadow-lg" data-id="element-359" />
              </div>
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4 leading-tight uppercase drop-shadow-[0_0_15px_rgba(255,255,255,0.15)]" data-id="element-360">
            ¡Reina, no te vayas todavía! ✨
          </h2>

          {/* Body */}
          <p className="text-slate-300 text-center mb-3 text-base leading-relaxed" data-id="element-361">
            Si llegaste hasta acá, es porque{' '}
            <span className="font-bold text-white" data-id="element-362">
              sabés que merecés mucho más de lo que estás recibiendo.
            </span>
          </p>
          <p className="text-slate-300 text-center mb-5 text-base leading-relaxed" data-id="element-363">
            Estás a un solo paso de recuperar tu energía, tu magnetismo y tu
            corona. No dejes pasar esta oportunidad de{' '}
            <span className="font-black text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f3e5ab]" data-id="element-364">
              transformar tu vida amorosa.
            </span>
          </p>

          {/* Auto-apply notice */}
          <div className="bg-red-950/30 border border-red-900/40 rounded-xl p-4 mb-6 flex items-start gap-3 shadow-[0_0_20px_rgba(153,27,27,0.12)]" data-id="element-365">
            <SparklesIcon className="h-5 w-5 text-[#d4af37] flex-shrink-0 mt-0.5" data-id="element-366" />
            <p className="text-sm text-red-200 font-semibold text-left" data-id="element-367">
              Recordá que hoy te llevás el programa completo + los 6 bonos
              exclusivos por un único pago de $19.990 ARS.
            </p>
          </div>

          {/* CTA Button */}
          <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" onClick={() => setIsVisible(false)} className="block w-full bg-gradient-to-r from-red-800 to-red-950 text-white font-black text-lg md:text-xl py-4 px-6 rounded-xl shadow-[0_0_30px_rgba(153,27,27,0.4)] hover:shadow-[0_0_50_rgba(153,27,27,0.6)] transform hover:scale-105 transition-all duration-300 text-center uppercase border border-red-700 animate-pulse-slow" data-id="element-368">
            SÍ, QUIERO MI TRATO DE REINA
          </a>

          {/* Dismiss link */}
          <button onClick={() => setIsVisible(false)} className="block w-full text-center text-sm text-slate-500 hover:text-slate-300 mt-4 transition-colors" data-id="element-369">
            No, prefiero seguir conformándome
          </button>
        </div>
      </div>
    </div>;
}